(function () {
  const PAGE_SECTIONS = [
    { id: 'main-cart-items', target: '#main-cart-items .js-contents', source: '.js-contents' },
    { id: 'main-cart-footer', target: '#main-cart-footer .js-contents', source: '.js-contents' },
    { id: 'cart-icon-bubble', target: '#cart-icon-bubble', source: '.shopify-section' },
  ];

  let busy = false;
  let failures = 0;

  function targets() {
    const list = [];
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      drawer.getSectionsToRender().forEach((s) => {
        list.push({
          id: s.id,
          target: s.selector || '#' + s.id,
          source: s.selector || '.shopify-section',
        });
      });
    }
    PAGE_SECTIONS.forEach((s) => {
      if (list.some((x) => x.id === s.id)) return;
      if (document.querySelector(s.target)) list.push(s);
    });
    return list;
  }

  // Not cart-drawer's own renderContents() — that force-opens the drawer.
  function renderQuiet(state) {
    if (!state || !state.sections) return;
    targets().forEach((s) => {
      const el = document.querySelector(s.target);
      const html = state.sections[s.id];
      if (!el || !html) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector(s.source);
      if (source) el.innerHTML = source.innerHTML;
    });
  }

  async function cartFetch(url, payload) {
    const body = Object.assign(
      { sections: targets().map((s) => s.id), sections_url: window.location.pathname },
      payload
    );
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const state = await res.json();
    if (state.status) throw new Error(state.description || state.message || 'Cart error');
    return state;
  }

  /* ---------- Auto-remove below threshold ---------- */

  async function removeExpiredGift() {
    if (busy || failures > 2) return;

    // Gift quantity above 1 — reset it. Must run BEFORE the expired check below,
    // which returns early whenever the cart still qualifies.
    const excess = document.querySelector('[data-free-gift-excess]');
    if (excess) {
      busy = true;
      try {
        renderQuiet(await cartFetch(window.routes.cart_change_url + '.js', {
          id: excess.getAttribute('data-free-gift-excess'),
          quantity: 1,
        }));
        failures = 0;
      } catch (err) {
        failures += 1;
        console.error('[free-gift] excess reset failed', err);
      } finally {
        setTimeout(function () { busy = false; }, 100);
      }
      return;
    }

    const flag = document.querySelector('[data-free-gift-expired]');
    if (!flag) return;
    const lineKey = flag.getAttribute('data-free-gift-expired');
    if (!lineKey) return;

    busy = true;
    try {
      const state = await cartFetch(window.routes.cart_change_url + '.js', {
        id: lineKey,
        quantity: 0,
      });
      renderQuiet(state);
      failures = 0;
    } catch (err) {
      failures += 1;
      console.error('[free-gift] auto-remove failed', err);
    } finally {
      setTimeout(function () { busy = false; }, 100);
    }
  }




  
  let expiryTimer;
  function scheduleCheck() {
    clearTimeout(expiryTimer);
    expiryTimer = setTimeout(removeExpiredGift, 250);
  }

  new MutationObserver(scheduleCheck).observe(document.body, { childList: true, subtree: true });
  scheduleCheck();

  /* ---------- Add / swap gift ---------- */

  document.addEventListener('click', async function (event) {
    const addBtn = event.target.closest('[data-free-gift-add]');
    const removeBtn = event.target.closest('[data-free-gift-remove]');
    if (!addBtn && !removeBtn) return;

    event.preventDefault();
    const button = addBtn || removeBtn;
    const wrap = button.closest('[data-free-gift]');
    if (wrap) wrap.classList.add('free-gift--busy');
    button.disabled = true;
    busy = true;

    try {
      const state = addBtn
        ? await cartFetch(window.routes.cart_add_url + '.js', {
            items: [{ id: Number(addBtn.dataset.variantId), quantity: 1 }],
          })
        : await cartFetch(window.routes.cart_change_url + '.js', {
            id: removeBtn.dataset.lineKey,
            quantity: 0,
          });
      renderQuiet(state);
    } catch (err) {
      console.error('[free-gift]', err);
      button.disabled = false;
      if (wrap) wrap.classList.remove('free-gift--busy');
    } finally {
      setTimeout(function () { busy = false; }, 100);
    }
  });
})();

/* ========== Carousel — arrows and dots ========== */

(function () {
  // getBoundingClientRect, not offsetLeft — offsetLeft is measured from the
  // nearest positioned ancestor and would be off by the drawer's offset.
  function itemOffsets(list) {
    const listLeft = list.getBoundingClientRect().left;
    return Array.from(list.children).map(
      (item) => item.getBoundingClientRect().left - listLeft + list.scrollLeft
    );
  }

  function activeIndex(list) {
    const offsets = itemOffsets(list);
    let best = 0;
    let bestDist = Infinity;
    offsets.forEach((off, i) => {
      const d = Math.abs(off - list.scrollLeft);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    return best;
  }

  function scrollToIndex(list, i) {
    const offsets = itemOffsets(list);
    if (!offsets.length) return;
    const clamped = Math.min(Math.max(i, 0), offsets.length - 1);
    list.scrollTo({ left: offsets[clamped], behavior: 'smooth' });
  }

  function syncNav(list) {
    const wrap = list.closest('[data-free-gift]');
    if (!wrap) return;
    const idx = activeIndex(list);
    wrap.querySelectorAll('[data-free-gift-dot]').forEach((d, i) => {
      d.classList.toggle('is-active', i === idx);
    });
    const prev = wrap.querySelector('[data-free-gift-prev]');
    const next = wrap.querySelector('[data-free-gift-next]');
    if (prev) prev.disabled = list.scrollLeft <= 1;
    if (next) next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
  }

  function syncAll() {
    document.querySelectorAll('.free-gift__list').forEach(syncNav);
  }

  let pending = false;
  function schedule(fn) {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; fn(); });
  }

  // scroll doesn't bubble — capture phase survives re-renders
  document.addEventListener('scroll', function (event) {
    const list = event.target;
    if (!list || !list.classList || !list.classList.contains('free-gift__list')) return;
    schedule(function () { syncNav(list); });
  }, true);

  document.addEventListener('click', function (event) {
    const dot = event.target.closest('[data-free-gift-dot]');
    const prev = event.target.closest('[data-free-gift-prev]');
    const next = event.target.closest('[data-free-gift-next]');
    if (!dot && !prev && !next) return;

    const wrap = event.target.closest('[data-free-gift]');
    const list = wrap && wrap.querySelector('.free-gift__list');
    if (!list) return;

    if (dot) scrollToIndex(list, Number(dot.dataset.freeGiftDot));
    else scrollToIndex(list, activeIndex(list) + (next ? 1 : -1));
  });

  new MutationObserver(function () { schedule(syncAll); })
    .observe(document.body, { childList: true, subtree: true });

  syncAll();
})();